import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import * as RoutesAuthentication from './RoutesAuthentication';
import ChatAppRoutes from './ChatAppRoutes';
import PublicRoutes from './PublicRoutes';
import SettingsRoutes from './SettingsRoutes';
import Logout from '../pages/ChatAppViews/Logout';

// Lazy layouts
const AppShellLayout = React.lazy(() => import('../layout/AppShellLayout'));
const ChatAppLayout = React.lazy(() => import('../layout/ChatAppLayout'));
const PublicLayout = React.lazy(() => import('../layout/PublicLayout'));
const SettingsLayout = React.lazy(() => import('../layout/SettingsLayout'));


const AppRouter = createBrowserRouter([
    {
        element: <RoutesAuthentication.PublicRoute />,
        children: [
            {
                path: "user",
                element: <PublicLayout />,
                children: PublicRoutes,
            },
        ]
    },
    {
        element: <RoutesAuthentication.PrivateRoute />,
        children: [
            {
                element: <AppShellLayout />,
                children: [
                    {
                        path: "/",
                        element: <ChatAppLayout />,
                        children: ChatAppRoutes,
                    },
                    {
                        path: "settings",
                        element: <SettingsLayout />,
                        children: SettingsRoutes,
                    },
                ],
            },
        ],
    },
    {
        path: "/user/logout",
        element: <Logout />,
    },
], {
        future: {
            v7_startTransition: true,
            v7_relativeSplatPath: true,
        }
    }
);

export default AppRouter;
